import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Loader2, LineChart as LineIcon } from 'lucide-react';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from 'recharts';
import api from '../../utils/axios';
import { fmtFecha, fmtMoney } from './vigilanciaUtils';

const RANGOS = [{ h: 24, l: '24 h' }, { h: 72, l: '3 días' }, { h: 168, l: '7 días' }, { h: 720, l: '30 días' }];
const compact = (v) => new Intl.NumberFormat('es-AR', { notation: 'compact', maximumFractionDigits: 1 }).format(v);

export const HistorialDialog = ({ vig, onOpenChange }) => {
  const [horas, setHoras] = useState(72);
  const [rows, setRows] = useState(null);

  useEffect(() => {
    if (!vig) return;
    setRows(null);
    api.get(`/vigilancia/cuentas/${vig.id}/historial`, { params: { horas } })
      .then((r) => setRows(r.data.items.map((x) => ({ ...x, t: fmtFecha(x.ts) }))))
      .catch(() => setRows([]));
  }, [vig, horas]);

  return (
    <Dialog open={!!vig} onOpenChange={onOpenChange}>
      <DialogContent className="vig-scope max-w-3xl" data-testid="vig-historial-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><LineIcon size={18} className="text-teal-700" /> Evolución de {vig?.nombre}</DialogTitle>
          <DialogDescription>Saldo disponible y consumo de límites en cada chequeo.</DialogDescription>
        </DialogHeader>
        <div className="flex gap-1.5">
          {RANGOS.map((r) => (
            <Button key={r.h} size="sm" variant={horas === r.h ? 'default' : 'outline'} onClick={() => setHoras(r.h)}
              className={horas === r.h ? 'bg-teal-700 hover:bg-teal-800' : ''} data-testid={`vig-historial-rango-${r.h}`}>{r.l}</Button>
          ))}
        </div>
        <div className="h-[320px]">
          {!rows && <div className="h-full flex items-center justify-center"><Loader2 className="animate-spin text-slate-400" /></div>}
          {rows && rows.length === 0 && <div className="h-full flex items-center justify-center text-sm text-slate-500">Todavía no hay chequeos en este rango.</div>}
          {rows && rows.length > 0 && (
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={rows} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                <XAxis dataKey="t" tick={{ fontSize: 10 }} minTickGap={30} />
                <YAxis tickFormatter={compact} tick={{ fontSize: 10 }} width={50} />
                <Tooltip formatter={(v) => fmtMoney(v)} />
                <Legend wrapperStyle={{ fontSize: 12 }} />
                <Line type="monotone" dataKey="disponible" name="Saldo disponible" stroke="#0f766e" strokeWidth={2} dot={false} />
                <Line type="monotone" dataKey="consumido_diario" name="Consumido hoy" stroke="#d97706" strokeWidth={2} dot={false} />
                <Line type="monotone" dataKey="consumido_mensual" name="Consumido en el mes" stroke="#6366f1" strokeWidth={2} dot={false} />
              </LineChart>
            </ResponsiveContainer>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default HistorialDialog;
